<template>
  <section class="lego-grid__row">
    <slot />
  </section>
</template>

<script>
export default {
  name: 'lego-grid-row',
};
</script>
